'use client'

import { Suspense } from 'react'
import { useRouter } from 'next/navigation'
import { useSearch } from '@/src/contexts'

export const PhysiciansSectionLink = () => {
  const router = useRouter()
  const { setLocationError } = useSearch()

  const handleSearchAvailability = () => {
    setLocationError(null)
    router.push('/search')
  }

  return (
    <Suspense>
      <button
        onClick={handleSearchAvailability}
        className='inline-block text-base md:text-medium hover:text-primary-dark'
      >
        Physicians
      </button>
    </Suspense>
  )
}
